import React from "react";
import Modal from "react-bootstrap/Modal";
import HeaderSimplified from "../HeaderSimplified";

const CartHowToPayHeader = ({setShowRewardsAlternatePaymentOption}) => {
    return (
        <Modal.Header className="cart-popup__header cart-popup__header--how-to-pay">
            <Modal.Title
                as={"div"}
                className="cart-popup__title"
            >
                <HeaderSimplified
                    action={() => setShowRewardsAlternatePaymentOption(false)}
                />
            </Modal.Title>
        </Modal.Header>
    );
}

export default CartHowToPayHeader;